import { Box, Button, Overlay } from "designSystem/index";
import React, { useState } from "react";

export default () => {
	const [open, setOpen] = useState(false);

	const onButton = () => {
		setOpen(true);
		setTimeout(() => setOpen(false), 2000);
	};

	return (
		<Box position="relative" py={5}>
			<Button design="primary" onClick={onButton}>
				Popup Overlay
			</Button>
			<Overlay open={open} />
		</Box>
	);
};